import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  orderBy,
  where,
  serverTimestamp
} from 'firebase/firestore';
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from 'firebase/storage';
import { db, storage } from '../firebase';
import {
  sendLowStockAlert,
  sendOutOfStockAlert
} from './emailService';

// ==================== KOLEKSİYON ====================
const productsCollection = collection(db, 'Products');

// ⚙️ AYARLAR - Admin e-posta adresi
const ADMIN_EMAIL = 'info@tronapazarlama.com';
const LOW_STOCK_THRESHOLD_PERCENTAGE = 50;

// ==================== YARDIMCI FONKSİYONLAR ====================

/**
 * Stok durumunu kontrol et ve gerekirse mail gönder
 */
const checkStockAndNotify = async (productId, productData, oldStock = null) => {
  const { stock, minStock = 5, name, sku, category } = productData;

  if (oldStock !== null && stock >= oldStock) {
    return;
  }

  if (stock === 0) {
    console.log('🚨 STOK TÜKENDİ - Mail gönderiliyor:', name);
    await sendOutOfStockAlert({
      productName: name,
      sku: sku || `PRD-${productId}`,
      category: category || 'Genel',
      lastSaleDate: new Date().toISOString()
    }, ADMIN_EMAIL);
  }
  else if (stock <= minStock) {
    console.log('⚠️ DÜŞÜK STOK - Mail gönderiliyor:', name, `(${stock}/${minStock})`);
    await sendLowStockAlert({
      productName: name,
      sku: sku || `PRD-${productId}`,
      currentStock: stock,
      minStock: minStock,
      category: category || 'Genel'
    }, ADMIN_EMAIL);
  }
  else if (stock <= (minStock * (LOW_STOCK_THRESHOLD_PERCENTAGE / 100))) {
    console.log('⚠️ STOK KRİTİK SEVİYEDE - Mail gönderiliyor:', name);
    await sendLowStockAlert({
      productName: name,
      sku: sku || `PRD-${productId}`,
      currentStock: stock,
      minStock: minStock,
      category: category || 'Genel'
    }, ADMIN_EMAIL);
  }
};

// ==================== ÜRÜN YÖNETİMİ ====================

/**
 * 🆕 Yeni Ürün Ekleme - Resim ve Video Desteği
 */
export const addProduct = async (productData, imageFiles = [], videoFiles = []) => {
  try {
    let imageUrls = [];
    let videoUrls = [];

    // 🖼️ Çoklu görsel upload
    if (imageFiles && imageFiles.length > 0) {
      console.log(`📸 ${imageFiles.length} resim yükleniyor...`);
      const uploadPromises = imageFiles.map(async (file) => {
        const storageRef = ref(
          storage,
          `products/images/${Date.now()}_${file.name}`
        );
        const snapshot = await uploadBytes(storageRef, file);
        const url = await getDownloadURL(snapshot.ref);
        console.log('✅ Resim yüklendi:', url);
        return url;
      });

      imageUrls = await Promise.all(uploadPromises);
    }

    // 🎥 Çoklu video upload
    if (videoFiles && videoFiles.length > 0) {
      console.log(`🎥 ${videoFiles.length} video yükleniyor...`);
      const uploadPromises = videoFiles.map(async (file) => {
        const storageRef = ref(
          storage,
          `products/videos/${Date.now()}_${file.name}`
        );
        const snapshot = await uploadBytes(storageRef, file);
        const url = await getDownloadURL(snapshot.ref);
        console.log('✅ Video yüklendi:', url);
        return url;
      });

      videoUrls = await Promise.all(uploadPromises);
    }

    // ✅ shippingFee güvenli number dönüşümü
    const shippingFee =
      productData.shippingFee !== undefined &&
      productData.shippingFee !== null
        ? Number(productData.shippingFee)
        : 0;

    const docRef = await addDoc(productsCollection, {
      ...productData,

      // 🖼️ GÖRSELLER
      images: imageUrls,              // 🔥 çoklu görsel
      image: imageUrls[0] || '',       // 🔙 geriye dönük uyum

      // 🎥 VİDEOLAR
      videos: videoUrls,              // 🔥 çoklu video

      // 📦 Varsayılanlar
      sales: productData.sales || 0,
      likes: productData.likes || 0,
      rating: productData.rating || 0,
      views: 0,

      // 💰 Fiyat
      originalPrice: productData.price,
      currentPrice: productData.currentPrice || productData.price,
      shippingFee: shippingFee,

      // 🔖 İndirim
      discount: productData.discount || 0,
      discountType: productData.discountType || 'none',
      discountValue: productData.discountValue || 0,
      discountStartDate: productData.discountStartDate || null,
      discountEndDate: productData.discountEndDate || null,

      // ⭐ Durumlar
      isFeatured: productData.isFeatured || false,
      isActive:
        productData.isActive !== undefined
          ? productData.isActive
          : true,

      // 📊 Stok
      stock: Number(productData.stock || 0),
      minStock: Number(productData.minStock || 5),
      maxStock: Number(productData.maxStock || 1000),

      // 🆔 Tanımlayıcılar
      sku: productData.sku || `SKU-${Date.now()}`,
      barcode: productData.barcode || '',
      brand: productData.brand || '',
      tags:
        typeof productData.tags === 'string'
          ? productData.tags.split(',').map(t => t.trim())
          : productData.tags || [],
      variants: productData.variants || [],

      // ⏱️ Zaman
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    console.log('✅ Ürün başarıyla eklendi:', docRef.id);
    console.log(`📸 ${imageUrls.length} resim, 🎥 ${videoUrls.length} video yüklendi`);

    // 📧 Stok mail kontrolü
    await checkStockAndNotify(docRef.id, productData);

    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('❌ Ürün eklenirken hata:', error);
    return { success: false, error: error.message };
  }
};

// ✅ ADMIN İÇİN - TÜM ÜRÜNLERİ GETİR (Video Desteği ile)
export const getAllProducts = async () => {
  try {
    const q = query(productsCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);

    const products = [];
    querySnapshot.forEach((document) => {
      const data = document.data();

      const images = Array.isArray(data.images) ? data.images : (data.images ? [data.images] : []);
      const videos = Array.isArray(data.videos) ? data.videos : (data.videos ? [data.videos] : []);
      
      // ✅ ShippingFee'yi kontrol et ve number'a çevir
      const shippingFee = data.shippingFee !== undefined && data.shippingFee !== null
        ? Number(data.shippingFee)
        : 0;

      products.push({
        id: document.id,
        ...data,
        images: images,
        image: images[0] || '',
        videos: videos.filter(v => v), // Boş değerleri filtrele
        shippingFee: shippingFee
      });
    });

    console.log('📦 Yüklenen ürün sayısı:', products.length);
    console.log('🎥 Videolu ürün sayısı:', products.filter(p => p.videos && p.videos.length > 0).length);

    return { success: true, products };
  } catch (error) {
    console.error('❌ Ürünler getirilirken hata:', error);
    return { success: false, error: error.message };
  }
};

// ✅ MÜŞTERİ İÇİN - SADECE STOKTA OLAN ÜRÜNLERİ GETİR (Video Desteği ile)
export const getAvailableProducts = async () => {
  try {
    const q = query(
      productsCollection,
      where('stock', '>', 0),
      where('isActive', '==', true),
      orderBy('stock', 'desc'),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(q);

    const products = [];
    querySnapshot.forEach((document) => {
      const data = document.data();

      const images = Array.isArray(data.images) ? data.images : (data.images ? [data.images] : []);
      const videos = Array.isArray(data.videos) ? data.videos : (data.videos ? [data.videos] : []);
      
      const shippingFee = data.shippingFee !== undefined && data.shippingFee !== null
        ? Number(data.shippingFee)
        : 0;

      products.push({
        id: document.id,
        ...data,
        images: images,
        image: images[0] || '',
        videos: videos.filter(v => v),
        shippingFee: shippingFee
      });
    });

    return { success: true, products };
  } catch (error) {
    console.error('❌ Stokta olan ürünler getirilirken hata:', error);

    try {
      const allQuery = query(productsCollection, orderBy('createdAt', 'desc'));
      const allSnapshot = await getDocs(allQuery);

      const products = [];
      allSnapshot.forEach((document) => {
        const data = document.data();
        if (data.stock > 0 && data.isActive !== false) {
          const images = Array.isArray(data.images) ? data.images : (data.images ? [data.images] : []);
          const videos = Array.isArray(data.videos) ? data.videos : (data.videos ? [data.videos] : []);

          const shippingFee = data.shippingFee !== undefined && data.shippingFee !== null
            ? Number(data.shippingFee)
            : 0;

          products.push({
            id: document.id,
            ...data,
            images: images,
            image: images[0] || '',
            videos: videos.filter(v => v),
            shippingFee: shippingFee
          });
        }
      });

      return { success: true, products };
    } catch (fallbackError) {
      console.error('❌ Fallback sorgu da başarısız:', fallbackError);
      return { success: false, error: fallbackError.message };
    }
  }
};

export const getProductById = async (productId) => {
  try {
    const productRef = doc(db, 'Products', productId);
    const snapshot = await getDoc(productRef);

    if (!snapshot.exists()) {
      return { success: false, error: 'Ürün bulunamadı' };
    }

    const data = snapshot.data();
    
    const images = Array.isArray(data.images) ? data.images : (data.images ? [data.images] : []);
    const videos = Array.isArray(data.videos) ? data.videos : (data.videos ? [data.videos] : []);
    
    const shippingFee = data.shippingFee !== undefined && data.shippingFee !== null
      ? Number(data.shippingFee)
      : 0;

    return {
      success: true,
      product: {
        id: snapshot.id,
        ...data,
        images: images,
        image: images[0] || '',
        videos: videos.filter(v => v),
        shippingFee: shippingFee
      }
    };
  } catch (error) {
    console.error('❌ getProductById error:', error);
    return { success: false, error: error.message };
  }
};

// productService.js - updateProduct fonksiyonunun güncellenmiş hali

/**
 * 🔥 Ürün Güncelleme - Medya Silme Destekli
 */
export const updateProduct = async (
  productId,
  updatedData,
  newImageFiles = [],
  newVideoFiles = []
) => {
  try {
    const productRef = doc(db, 'Products', productId);
    const currentDoc = await getDoc(productRef);

    if (!currentDoc.exists()) {
      return { success: false, error: 'Ürün bulunamadı' };
    }

    const currentData = currentDoc.data();
    const oldStock = currentData.stock ?? null;

    console.log('🔄 Güncelleme başlıyor:', {
      productId,
      mevcutResimler: updatedData.existingImages?.length || 0,
      mevcutVideolar: updatedData.existingVideos?.length || 0,
      yeniResimler: newImageFiles.length,
      yeniVideolar: newVideoFiles.length,
      silinecekResimler: updatedData.imagesToDelete?.length || 0,
      silinecekVideolar: updatedData.videosToDelete?.length || 0
    });

    // 🔥 1. SİLİNECEK RESİMLERİ SİL
    if (updatedData.imagesToDelete && updatedData.imagesToDelete.length > 0) {
      console.log('🗑️ Resimler siliniyor...', updatedData.imagesToDelete.length);
      for (const imageUrl of updatedData.imagesToDelete) {
        try {
          const imageRef = ref(storage, imageUrl);
          await deleteObject(imageRef);
          console.log('✅ Resim silindi:', imageUrl);
        } catch (err) {
          console.log('⚠️ Resim silinemedi (göz ardı edildi):', imageUrl, err.message);
        }
      }
    }

    // 🔥 2. SİLİNECEK VİDEOLARI SİL
    if (updatedData.videosToDelete && updatedData.videosToDelete.length > 0) {
      console.log('🗑️ Videolar siliniyor...', updatedData.videosToDelete.length);
      for (const videoUrl of updatedData.videosToDelete) {
        try {
          const videoRef = ref(storage, videoUrl);
          await deleteObject(videoRef);
          console.log('✅ Video silindi:', videoUrl);
        } catch (err) {
          console.log('⚠️ Video silinemedi (göz ardı edildi):', videoUrl, err.message);
        }
      }
    }

    // 🖼️ 3. YENİ RESİMLERİ YÜKLE
    let newImageUrls = [];
    if (newImageFiles && newImageFiles.length > 0) {
      console.log(`📸 ${newImageFiles.length} yeni resim yükleniyor...`);
      const uploadPromises = newImageFiles.map(async (file) => {
        const storageRef = ref(
          storage,
          `products/images/${Date.now()}_${file.name}`
        );
        const snapshot = await uploadBytes(storageRef, file);
        const url = await getDownloadURL(snapshot.ref);
        console.log('✅ Resim yüklendi:', url);
        return url;
      });

      newImageUrls = await Promise.all(uploadPromises);
    }

    // 🎥 4. YENİ VİDEOLARI YÜKLE
    let newVideoUrls = [];
    if (newVideoFiles && newVideoFiles.length > 0) {
      console.log(`🎥 ${newVideoFiles.length} yeni video yükleniyor...`);
      const uploadPromises = newVideoFiles.map(async (file) => {
        const storageRef = ref(
          storage,
          `products/videos/${Date.now()}_${file.name}`
        );
        const snapshot = await uploadBytes(storageRef, file);
        const url = await getDownloadURL(snapshot.ref);
        console.log('✅ Video yüklendi:', url);
        return url;
      });

      newVideoUrls = await Promise.all(uploadPromises);
    }

    // 🧩 5. MEDYA DİZİLERİNİ BİRLEŞTİR
    // Mevcut (silinmemiş) + yeni eklenenler
    const finalImages = [
      ...(updatedData.existingImages || []),
      ...newImageUrls
    ];

    const finalVideos = [
      ...(updatedData.existingVideos || []),
      ...newVideoUrls
    ];

    console.log('📊 Final medya sayıları:', {
      toplamResim: finalImages.length,
      toplamVideo: finalVideos.length
    });

    // 💰 shippingFee güvenli dönüşüm
    const shippingFee =
      updatedData.shippingFee !== undefined &&
      updatedData.shippingFee !== null
        ? Number(updatedData.shippingFee)
        : Number(currentData.shippingFee || 0);

    // 📦 Güncellenecek veri
    const dataToUpdate = {
      ...updatedData,

      // 🖼️ Görseller (silinmeyenler + yeniler)
      images: finalImages,
      image: finalImages[0] || '', // 🔙 uyumluluk

      // 🎥 Videolar (silinmeyenler + yeniler)
      videos: finalVideos,

      // 💰 Fiyat
      originalPrice:
        updatedData.originalPrice ?? currentData.originalPrice,
      currentPrice:
        updatedData.currentPrice ??
        currentData.currentPrice ??
        updatedData.price ??
        currentData.price,

      shippingFee: shippingFee,

      // 📊 Stok
      stock:
        updatedData.stock !== undefined
          ? Number(updatedData.stock)
          : Number(currentData.stock || 0),
      minStock:
        updatedData.minStock !== undefined
          ? Number(updatedData.minStock)
          : Number(currentData.minStock || 5),
      maxStock:
        updatedData.maxStock !== undefined
          ? Number(updatedData.maxStock)
          : Number(currentData.maxStock || 1000),

      // 🔖 Etiketler
      tags:
        typeof updatedData.tags === 'string'
          ? updatedData.tags.split(',').map(t => t.trim())
          : updatedData.tags ?? currentData.tags ?? [],

      // ⭐ Durumlar
      isActive:
        updatedData.isActive !== undefined
          ? updatedData.isActive
          : currentData.isActive,
      isFeatured:
        updatedData.isFeatured !== undefined
          ? updatedData.isFeatured
          : currentData.isFeatured,

      // ⏱️ Zaman
      updatedAt: serverTimestamp(),

      // 🔥 Silme listelerini Firestore'a kaydetme (temiz tutmak için)
      existingImages: undefined,
      existingVideos: undefined,
      imagesToDelete: undefined,
      videosToDelete: undefined
    };

    // Undefined değerleri temizle
    Object.keys(dataToUpdate).forEach(key => {
      if (dataToUpdate[key] === undefined) {
        delete dataToUpdate[key];
      }
    });

    await updateDoc(productRef, dataToUpdate);

    console.log('✅ Ürün başarıyla güncellendi:', productId);
    console.log(`📸 Toplam resim: ${finalImages.length}, 🎥 Toplam video: ${finalVideos.length}`);

    // 📧 Stok değişimi kontrolü
    await checkStockAndNotify(productId, dataToUpdate, oldStock);

    // 🔄 Güncel veriyi geri döndür
    const updatedSnap = await getDoc(productRef);
    const finalData = updatedSnap.data();

    return {
      success: true,
      product: {
        id: updatedSnap.id,
        ...finalData,
        shippingFee: Number(finalData.shippingFee || 0),
        images: finalData.images || [],
        videos: finalData.videos || []
      }
    };
  } catch (error) {
    console.error('❌ Ürün güncellenirken hata:', error);
    return { success: false, error: error.message };
  }
};

/**
 * 🆕 Ürün Silme - Video desteği ile
 */
export const deleteProduct = async (productId, imageUrls = [], videoUrls = []) => {
  try {
    // 🖼️ Resimleri sil
    if (imageUrls && imageUrls.length > 0) {
      for (const imageUrl of imageUrls) {
        try {
          const imageRef = ref(storage, imageUrl);
          await deleteObject(imageRef);
          console.log('🗑️ Resim silindi:', imageUrl);
        } catch (err) {
          console.log('⚠️ Resim silinirken hata (göz ardı edildi):', err);
        }
      }
    }

    // 🎥 Videoları sil
    if (videoUrls && videoUrls.length > 0) {
      for (const videoUrl of videoUrls) {
        try {
          const videoRef = ref(storage, videoUrl);
          await deleteObject(videoRef);
          console.log('🗑️ Video silindi:', videoUrl);
        } catch (err) {
          console.log('⚠️ Video silinirken hata (göz ardı edildi):', err);
        }
      }
    }

    const productRef = doc(db, 'Products', productId);
    await deleteDoc(productRef);

    console.log('✅ Ürün başarıyla silindi:', productId);
    return { success: true };
  } catch (error) {
    console.error('❌ Ürün silinirken hata:', error);
    return { success: false, error: error.message };
  }
};

export const getProductLikes = async (productId) => {
  try {
    const result = await getProductById(productId);
    if (result.success) {
      return { success: true, likes: result.product.likes || 0 };
    }
    return { success: false, likes: 0 };
  } catch (error) {
    console.error('❌ getProductLikes error:', error);
    return { success: false, error: error.message, likes: 0 };
  }
};

// ✅ MÜŞTERİ İÇİN - Sadece stokta olanları getir (Video desteği ile)
export const getMostLikedProducts = async (limit = 10) => {
  try {
    const q = query(
      productsCollection,
      where('stock', '>', 0),
      where('isActive', '==', true),
      orderBy('stock', 'desc'),
      orderBy('likes', 'desc')
    );
    const querySnapshot = await getDocs(q);

    const products = [];
    querySnapshot.forEach((document) => {
      const data = document.data();
      const shippingFee = data.shippingFee !== undefined && data.shippingFee !== null
        ? Number(data.shippingFee)
        : 0;

      const images = Array.isArray(data.images) ? data.images : (data.images ? [data.images] : []);
      const videos = Array.isArray(data.videos) ? data.videos : (data.videos ? [data.videos] : []);

      products.push({
        id: document.id,
        ...data,
        images: images,
        image: images[0] || '',
        videos: videos.filter(v => v),
        shippingFee: shippingFee
      });
    });

    return { success: true, products: products.slice(0, limit) };
  } catch (error) {
    console.error('❌ getMostLikedProducts error:', error);

    try {
      const allQuery = query(productsCollection, orderBy('likes', 'desc'));
      const allSnapshot = await getDocs(allQuery);

      const products = [];
      allSnapshot.forEach((document) => {
        const data = document.data();
        if (data.stock > 0 && data.isActive !== false) {
          const shippingFee = data.shippingFee !== undefined && data.shippingFee !== null
            ? Number(data.shippingFee)
            : 0;

          const images = Array.isArray(data.images) ? data.images : (data.images ? [data.images] : []);
          const videos = Array.isArray(data.videos) ? data.videos : (data.videos ? [data.videos] : []);

          products.push({
            id: document.id,
            ...data,
            images: images,
            image: images[0] || '',
            videos: videos.filter(v => v),
            shippingFee: shippingFee
          });
        }
      });

      return { success: true, products: products.slice(0, limit) };
    } catch (fallbackError) {
      return { success: false, error: fallbackError.message };
    }
  }
};

// ✅ MÜŞTERİ İÇİN - Sadece stokta olanları getir (Video desteği ile)
export const getBestSellingProducts = async (limit = 10) => {
  try {
    const q = query(
      productsCollection,
      where('stock', '>', 0),
      where('isActive', '==', true),
      orderBy('stock', 'desc'),
      orderBy('sales', 'desc')
    );
    const querySnapshot = await getDocs(q);

    const products = [];
    querySnapshot.forEach((document) => {
      const data = document.data();
      if ((data.sales || 0) > 0) {
        const shippingFee = data.shippingFee !== undefined && data.shippingFee !== null
          ? Number(data.shippingFee)
          : 0;

        const images = Array.isArray(data.images) ? data.images : (data.images ? [data.images] : []);
        const videos = Array.isArray(data.videos) ? data.videos : (data.videos ? [data.videos] : []);

        products.push({
          id: document.id,
          ...data,
          images: images,
          image: images[0] || '',
          videos: videos.filter(v => v),
          shippingFee: shippingFee
        });
      }
    });

    return { success: true, products: products.slice(0, limit) };
  } catch (error) {
    console.error('❌ getBestSellingProducts error:', error);

    try {
      const allQuery = query(productsCollection, orderBy('sales', 'desc'));
      const allSnapshot = await getDocs(allQuery);

      const products = [];
      allSnapshot.forEach((document) => {
        const data = document.data();
        if (data.stock > 0 && data.isActive !== false && (data.sales || 0) > 0) {
          const shippingFee = data.shippingFee !== undefined && data.shippingFee !== null
            ? Number(data.shippingFee)
            : 0;

          const images = Array.isArray(data.images) ? data.images : (data.images ? [data.images] : []);
          const videos = Array.isArray(data.videos) ? data.videos : (data.videos ? [data.videos] : []);

          products.push({
            id: document.id,
            ...data,
            images: images,
            image: images[0] || '',
            videos: videos.filter(v => v),
            shippingFee: shippingFee
          });
        }
      });

      return { success: true, products: products.slice(0, limit) };
    } catch (fallbackError) {
      return { success: false, error: fallbackError.message, products: [] };
    }
  }
};

export default {
  addProduct,
  getAllProducts,
  getAvailableProducts,
  getProductById,
  updateProduct,
  deleteProduct,
  getProductLikes,
  getMostLikedProducts,
  getBestSellingProducts
};